const FALLBACK_LOCALE = 'en-GB';

/**
 * Parses the locale from the query parameter and returns it if it exists
 */
export const getLocale = (): string => {
  const searchParams = new URLSearchParams(window.location.search);
  const locale = searchParams.get('locale') || getLocaleFromPath();
  if (locale) {
    const language = locale.split('-')[0]?.toLowerCase();
    const country = locale.split('-')[1]?.toUpperCase();
    return `${language}-${country}`;
  }

  return FALLBACK_LOCALE;
};

export const getCountry = (locale?: string): string => {
  return (locale || getLocale()).split('-')[1];
};

export const getLanguage = (locale?: string): string => {
  return (locale || getLocale()).split('-')[0];
};

const getLocaleFromPath = (): string | null => {
  const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})\//);
  return match ? match[2] + '-' + match[1].toUpperCase() : null;
};

/**
 * Check if market is North American
 */
export const isNAMarket = () => ['US', 'CA', 'DO', 'MX', 'PR'].includes(getCountry());
